import {ApiConfiguration} from "./ApiConfiguration";
import {ServiceConfiguration} from "./ServicesConfiguration";
// import {TemplateConfiguration} from "../template/configuration/TemplateConfiguration";

export class AppConfiguration {
    static configure() {
        ApiConfiguration.configure();
        // TemplateConfiguration.configure();
        ServiceConfiguration.configure();
    }
}
